var exports = {
  "k": "xdde3148b--bd7539--container",
  "Q": "xdde3148b--bd7539--content",
};

module.exports = exports;
